import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginContextResolver } from './login-context.resolver';
import { LoginComponent } from './login.component';
import { EnsureLoggedOutGuard } from '../common/guards/ensure-logged-out.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [EnsureLoggedOutGuard],
    resolve: {
      loginContext: LoginContextResolver,
    },
  },
  {
    path: 'Account/Login',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
